import { EmptyStateWithImage } from "src/components/EmptyState/EmptyStateWithImage"
import { useTranslate } from "src/i18n/useTranslate"

import NoCompletedTasksEmptyStateImage from "./images/no-tasks.svg"

export function NoCompletedTasks() {
  const { tPlaceholder } = useTranslate()

  return (
    <EmptyStateWithImage
      Image={NoCompletedTasksEmptyStateImage}
      title={tPlaceholder("Review completed tasks")}
      description={tPlaceholder(
        "Keep track of finished tasks. Complete your first task to get started."
      )}
    />
  )
}
